<template>
    <div class="container-fluid w-100" style="overflow: hidden">
        <navbar :title="$t('notification_list.title')"/>
        <div class="col-sm-12 nopads mt-2 list-container">
            <!-- Lists-->
            <Transition name="fade">
                <div
                    v-if="lists.length > 0"
                    id="accordion"
                    class="col-sm-12 list-content result-table"
                >
                    <vue3-datatable
                        ref="resultTable"
                        :rows="lists"
                        :columns="fields"
                        :pagination="false"
                        :sticky-header="true"
                        height="100%"
                        :sortable="true"
                        skin="bh-table-compact"
                        row-class="routa-table-row"
                        cell-class="routa-table-cell"
                        @row-click="editList"
                    >

                    </vue3-datatable>
                </div>
            </Transition>
        </div>

        <!--     Editor-->
        <base-modal v-if="editMode" hide-header hide-footer @close="editMode = close">
            <notification-list-editor
                v-if="editMode"
                :list="list"
                @close="close()"
                @closeAndUpdate="closeAndUpdate"/>
        </base-modal>
        <div v-if="loading"
             id="loader"
             class="spinner">
        </div>
    </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import NotificationListEditor from '@/components/notifications/NotificationListEditor'
import Navbar from "@/components/utils/Navbar";
import BaseModal from "@/components/BaseModal";
import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: 'notification-lists',
    mixins: [restApi],
    components: {BaseModal, Navbar, NotificationListEditor, Vue3Datatable},
    data: function () {
        return {
            EMERGENCY: 1,
            SAFETY: 2,
            WORK: 3,
            FINANCE: 4,
            loading: false,
            editMode: false,
            list: null,
            sortBy: 'topic',
        }
    },
    computed: {
        lists() {
            return [
                {topic: this.EMERGENCY, title: this.$t('notification_list.topic_emergency')},
                {topic: this.SAFETY, title: this.$t('notification_list.topic_safety')},
                {topic: this.WORK, title: this.$t('notification_list.topic_work')},
                {topic: this.FINANCE, title: this.$t('notification_list.topic_finance')}
            ]
        },
        fields() {
            return [
                {field: 'topic', title: this.$t('notification_list.id'), sort: true,  headerClass: 'routa-table-header'},
                {field: 'title', title: this.$t('notification_list.topic'), sort: true,  headerClass: 'routa-table-header'},
            ]
        }
    },
    methods: {
        editList: function (list) {
            this.list = list
            this.fetchSubscribers()
        },
        close: function () {
            this.editMode = false
        },
        closeAndUpdate: function () {
            this.editMode = false
        },
        fetchSubscribers() {
            this.loading = true
            this.restFetch(this.notificationSubsUrl + '/' + this.list.topic, this.handleSubs, this.handleError)
        },
        handleSubs: function (response) {
            if (response.data) {
                this.list.users = []
                response.data.forEach(item => this.list.users.push(item.user))
                this.editMode = true
            }
            this.loading = false
        },
        handleError() {
            this.loading = false
        }
    }
}
</script>
